<template>
  <div style="width:100%;float:left;">
    <!-- <div style="width:100%;float:left;">
      <search-orders></search-orders>
    </div> -->
    <div style="width:100%;float:left;">
      <CCard>
       <CCardHeader @click.prevent="changeCollapsed">
          Open Orders
          <div class="card-header-actions">
            <CLink
              class="card-header-action btn-minimize"
              
            >
              <CIcon :name="`cil-chevron-${collapsed ? 'bottom' : 'top'}`"/>
            </CLink>
          </div>
        </CCardHeader>

        <CCollapse :show="collapsed" :duration="400">
        <!-- Tabs -->
        <div class="tabs-wrapper mt-3 ml-3">
          <ul class="nav-tabs">
            <li :class="{ active: activeTab === 'Alerts' }" style="background-color: #f43d3d;" @click="activeTab = 'Alerts', onTabChange('Alerts')">
              Alerts past 48 hours 
              ({{ tabCounts.alerts > 0 ? tabCounts.alerts : '*' }})
            </li>
            <li :class="{ active: activeTab === 'Pending' }" @click="activeTab = 'Pending'">
              Pending ({{ tabCounts.pending }})
            </li>
            <li :class="{ active: activeTab === 'In Progress' }" @click="activeTab = 'In Progress'">
              In Progress ({{ tabCounts.inProgress }})
            </li>
            <li :class="{ active: activeTab === 'Pending Customer' }" @click="activeTab = 'Pending Customer'">
              Pending Customer ({{ tabCounts.pendingCustomer }})
            </li>
            <li :class="{ active: activeTab === 'In Production' }" @click="activeTab = 'In Production'">
              In Production ({{ tabCounts.inProd }})
            </li>
            <li :class="{ active: activeTab === 'All' }" @click="activeTab = 'All'">
              All ({{ tabCounts.all }})
            </li>
          </ul>
        </div>

        <CCardBody>

          <!-- <div class="date-filters d-flex align-items-center flex-wrap gap-2 mb-2" v-if="['all-orders', 'prebooks', 'events', 'fillins'].includes(activeTab)"> -->
          
          <div class="date-filters d-flex align-items-center flex-wrap gap-2 mb-2" v-if="activeTab !== 'Alerts'">
        
            <!-- Date Picker Based on Ship Date -->
            <div class="d-flex align-items-center me-3">
              <label class="time-label me-1 mb-0">From: </label>
              <date-picker class="ml-2"
                  v-model="startDate"
                  :format="'YYYY-MM-DD'"
                  :valueType="'format'"
                  :default-value="new Date()"
                  placeholder="Start Date"
              />
              </div>

              <div class="d-flex align-items-center me-3">
              <label class="time-label me-1 mb-0">To: </label>
              <date-picker class="ml-2"
                  v-model="endDate"
                  :format="'YYYY-MM-DD'"
                  :valueType="'format'"
                  :default-value="new Date()"
                  placeholder="End Date"
              />
              </div>

              <div class="d-flex align-items-center ml-2">
              <button
                  type="button"
                  class="btn btn-m btn-dark"
                  @click="onFilterDates"
              >
                  <span v-if="loading">Filtering…</span>
                  <span v-else>Filter Dates</span>
              </button>
            </div>
          </div>
          
          <div class="all text-center" v-if="showAll">
            <v-select style="width:200px;float:right;" :options="filterOptions" name="name" v-model="filter"></v-select>
          </div>
          <!-- <h5 style="width:100%;float:left;text-align: center;font-size:13px;">Click on row to go to order</h5> -->
          <!-- <div style="width:100%;float:left;text-align: center;"> -->
            <!-- <v-select style="width:500px;margin-left:auto;margin-right:auto;" placeholder="Select Customer" v-if="customerOptions" :options="customerOptions" name="name" label="label" v-model="customerFilter"></v-select> -->
            <!-- <CButton size="sm" class="mt-2" color="info" v-if="!downloadLoading" :disabled="selected.length ? false : true" @click="downloadOrders()">Combine & Email Selected PDF Orders (Max 30)</CButton> -->
          <!-- </div> -->
          <spacer />
          <!-- <div style="width:100%;float:left;" v-if="orders">{{orders.length}} Orders Showing</div> -->
          <div style="width:100%;float:left;" v-if="!loading">

            <!-- NON-ALERTS TABLE -->
            <CDataTable
              v-if="activeTab !== 'Alerts'"
              :key="'main-'+activeTab"
              :items="displayedOrders"
              :fields="fieldsMain"
              :items-per-page="15"
              pagination
              sorter
              column-filter
              table-filter
            >
              <!-- <template #check="{item}">
                <td>
                  <input type="checkbox" :checked="checkSelected(item)" @click="changeSelected(item)" />
                </td>
              </template> -->
              <!-- <template #order_id-header>
                  Order#
              </template> -->
              
              <template #as400_log_number-header>
                  Order Number
              </template>

              <template #so_number-header>
                  SO Number
              </template>
              <template #so_number="{item}">
                <td>
                  <a href="#" @click.prevent="goToOrder(item)">
                    {{ item.so_number }}
                  </a>
                </td>
              </template>

              <template #local_created_at-header>
                  Order Date
              </template>
              <template #po_number="{item}">
                <td>
                  {{ item.po_number }}
                </td>
              </template>

              <!-- TODO: link this completely to customer portal  -->
              <template #customer_name="{ item }">
                <td>
                  <a href="#" @click.prevent="goToCustomerPortal(item)">
                    {{ item.customer_name }}
                  </a>
                </td>
              </template>


              <template #price="{item}">
                <td>
                  ${{ (Number(item.price) || 0).toFixed(2) }}
                </td>
              </template>
              <template #program_name-header>
                  Program
              </template>

              <!-- <template #show="{item}">
                <td>
                  <div style="width:100px;">
                    <CButton size="sm" style="float:left;" color="primary" @click="quickView( item )"><CIcon name="cil-fullscreen" /></CButton>
                    <CButton size="sm" style="float:left;" color="success" @click="goToOrder( item )"><CIcon name="cil-arrow-right" /></CButton>
                  </div>
                </td>
              </template> -->
            </CDataTable>


            <!-- ALERTS SPECIFIC TABLE -->
            <template v-if="activeTab === 'Alerts'">
              <small-loader v-if="alertsLoading" />
             <CDataTable 
              v-else
              :key="'alerts'"
              :items="releaseChanges"
              :fields="fieldsAlerts"
              :items-per-page="15"
              :noItemsView="{ noItems: '', noResults: '' }"
              pagination
              sorter
              column-filter
              table-filter
            >
              <template #prev_status-header>
                Prev Status
              </template>
              <template #prev_status="{item}">
                  <td><CBadge :color="configureColor(item.prev_status)" style="font-size: 10px;">{{ getStatusLabel(item.prev_status)  || 'Order Entry' }}</CBadge></td>
              </template>

              <template #release_status_label-header>
                  Current Status
              </template>
              <template #release_status_label="{item}">
                <td>
                  <CBadge :color="configureColor(item.release_status_label)" style="font-size: 10px;">{{ getStatusLabel(item.release_status_label) }}</CBadge>
                </td>
              </template>

              <template #recent_status_changed_at-header>
                Status Last Changed
              </template>
              <template #recent_status_changed_at="{item}">
                  <td>{{ item.recent_status_changed_at || item.order_date }}</td>
              </template>

              <template #log_number-header>
                  Order Number
              </template>
              <template #log_number="{item}">
                <td>{{ item.log_number }}</td>
              </template>

              <template #so_number-header>
                  SO Number
              </template>
              <template #so_number="{item}">
                <td>
                  <a href="#" @click.prevent="goToOrder(item)">
                    {{ item.so_number }}
                  </a>
                </td>
              </template>

              <template #order_date-header>
                  Order Date
              </template>
              <template #order_date="{item}">
                <td>{{ item.order_date }}</td>
              </template>

              <template #po_number="{item}">
                <td>
                  {{ item.po_number }}
                </td>
              </template>

              <template #program_name-header>
                  Program
              </template>
              <template #program_name="{item}">
                <td>{{ item.program_name }}</td>
              </template>

              <!-- TODO: link this completely to customer portal  -->
              <template #customer_name="{ item }">
                <td>
                  <a href="#" @click.prevent="goToCustomerPortal(item)">
                    {{ item.customer_name }}
                  </a>
                </td>
              </template>

              <template #units="{item}">
                <td>
                  {{ item.units }}
                </td>
              </template>

              <template #total_dollars="{item}">
                <td>
                  ${{ (Number(item.total_dollars) || 0).toFixed(2) }}
                </td>
              </template>

            </CDataTable>
            </template>

          </div>
          <small-loader v-else></small-loader>
        </CCardBody>
        </CCollapse>
        </CCard>
      </div>

      <!-- Order PDF -->
      <!-- <adobe-pdf-viewer
        v-if="pdfModal && pdfData"
        from="customer_portal"
        :order_group="pdfData"
        pdf_type="either"
        :allowEdit="false"
        @closed="pdfModal = false; pdfData = null"
      /> -->

      <adobe-pdf-viewer v-if="pdfModal && pdfData" @closed="pdfModal = false; pdfData = null" :order_group="pdfData" pdf_type="either" :allowEdit="false"></adobe-pdf-viewer>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import AdobePdfViewer from './../components/adobe_pdf_viewer'

// axios assumed global in your app

var methods = {}

methods.onFilterDates = function () {
  this.getNewOrders()
}

methods.changeCollapsed = function () {
  this.collapsed = !this.collapsed
  if (this.collapsed) {
    this.getNewOrders()
  }
}

methods.getNewOrders = function () {
  // Require a CSR before fetching
  if (!this.csr || !this.csr.id) {
    console.debug('[OpenOrdersTable] skip fetch, no CSR yet:', this.csr)
    return
  }

  this.loading = true

  const postData = {
    csr: this.csr,                           // expects csr.internal_id on the backend
    customer_selected: this.customer_selected,
    start_date: this.startDate || null,      // 'YYYY-MM-DD'
    end_date:   this.endDate   || null,
    option: 'Open Orders'
  }

  console.log('[OpenOrdersTable] POST (getCsrOrders):', postData)

  axios.post(
    `${this.$apiAdress}/api/getCsrOrdersNew?token=${localStorage.getItem('api_token')}`,
    postData
  )
  .then((res) => {
    const body  = res.data || {}
    const items = Array.isArray(body) ? body : (body.items || [])

    this.orders = items  // pass-through like rep_open_orders

    this.selected = []
    this.$emit('orders-loaded', true)
  })
  .catch(err => {
    console.error(
      '[OpenOrdersTable] getCsrOrders failed:',
      // err?.response?.release_status_label,
      err?.response?.data || err?.message || err
    )
  })
  .finally(() => {
    this.loading = false
  })
}

methods.getReleaseChanges = function () {

  const postData = {
    csr_id: this.csr.id,                           // expects csr.internal_id on the backend
    customer_selected: this.customer_selected,
    start_date: this.startDate || null,      // 'YYYY-MM-DD'
    end_date:   this.endDate   || null
  }

  console.log('Release changes POST DATA------> ', postData)

  axios.post(
    `${this.$apiAdress}/api/getStatusChangeByRep?token=${localStorage.getItem('api_token')}`,
    postData
  )
  .then((res) => {
    const body = res && res.data ? res.data : {};
    const items = Array.isArray(body) ? body : (Array.isArray(body.items) ? body.items : []);

    console.log('here go da ALERTS roWWWSS...', items)


    this.releaseChanges = items.map(r => ({
      log_number:           r.log_number || '',
      so_number:            r.so_number || '',
      order_date:           r.order_date || '',
      po_number:            r.po_number || '',
      program_name:         r.program_name || r.custbody_mb_program || '',
      event:                r.event || '',
      _classes:             r.event === 'T' ? 'event-row' : '',
      units:                r.units || '',
      total_dollars:        r.total_dollars || '',
      customer_name:        r.customer_name || '',
      order_status_label:   r.order_status_label || '',
      release_status_label:       r.release_status_label || '',
      recent_status:        r.recent_status || null,
      prev_status:          r.prev_status || '',
      recent_status_changed_at:        r.recent_status_changed_at || '',
      
      exp_ship_date:        r.exp_ship_date || '',
      date_shipped:         r.date_shipped ||''
    }));
  })
  .catch((err) => {
    console.error('[soReleaseChanges] failed:', err?.response?.data || err?.message || err);
    this.releaseChanges = [];
  }).finally(() => {
      this.alertsLoading = false;           // <-- ensures spinner stops
      this.alertsLoaded  = true;
  });
}



 
// methods.getSavedOrders = function () {

//   if (!this.csr || !this.csr.id) {
//     console.debug('[OpenOrdersTable] skip fetch, no CSR yet:', this.csr)
//     return
//   }

//   console.log('CSR------: ', this.csr['internal_id'])

//   const postData = {
//     customer: this.customer_selected,
//     csr: this.csr,
//     start_date: this.startDate || null,   // YYYY-MM-DD from the pickers
//     end_date:   this.endDate   || null
//   }
//   axios.post(this.$apiAdress + '/api/orders/getSavedOrders?token=' + localStorage.getItem('api_token'), postData)
//   .then(res => {
//     const payload = res.data;
//     const rows = Array.isArray(payload) ? payload
//                : [];

//     console.log('SavedOrders rows:', rows.length);

//     this.savedOrders = rows.map(r => ({
//       id:                r.id || '',
//       orderNumber:       r.as400_log_number || r.order_number || null,
//       orderDate:         r.local_created_at || r.created_at || null,
//       customer:          r.customer_name || null,
//       poNumber:          r.po_number || '',
//       program:           r.program || r.program_name || null,
//       totalUnits:        r.total_units ?? 0,
//       orderTotal:        r.total_price ?? 0,
//       shipDate:          r.ship_date ?? '',
//       status:            r.as400_status || '',
//       alert:             r.alert_label ?? '',
//     }));

//     console.log('SavedOrderoooooos daTA rows:', this.savedOrders);
//   })
//   .catch(e => {
//     console.log(e)
//   })
//   .finally(() => {
//     this.loading = false
//   })
// }


methods.createFromSaved = function (order_id) {
  console.log('Row CLICKKed Vallyyyy', order_id)

  this.$router.push('/create_order/' + order_id + '/saved')
}

methods.disableFutureDates = function (date) {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return date > today
}

methods._toDate = function (mdy) {
  if (mdy instanceof Date) return mdy
  if (!mdy) return null
  // supports 'MM/DD/YYYY' and ISO
  if (mdy.includes('/')) {
    const [m, d, y] = mdy.split('/').map(Number)
    return new Date(y, (m || 1) - 1, d || 1)
  }
  return new Date(mdy)
}

methods.formatCurrency = function(n) {
  const num = Number(n).toFixed(2);
  // num = Number.isFinite(num) ? Math.round(num * 100) / 100 : 0;
  return num
}

methods.openOrder = function(item) {
  // TODO: wire to quick-view or route
  console.log('Open order clicked:', item.orderNumber)
}

// ONLY SHOW ROWS WHERE CURRENT STATUS = HOLR OR PENDING CUSTOMER
methods.getStatusLabel = function (status) {
  if (!status) return '';
  const s = String(status).toLowerCase();

  if (/pending|not released/.test(s)) {
    return 'Pending';
  }
  if (/in process|coloring|order entry|sent to art \(stitchout\)|sent to art \(component\)|sent to art \(artpack\)|sent to art \(import\)|sent to art \(world emblem\)/.test(s)) {
    return 'In Progress';
  }
  if (/sent off for approval|waiting on customer/.test(s)) {
    return 'Pending Customer';
  }
  if (/released|direct ship\/projection|drop ship\/projection/.test(s)) {
    return 'In Production';
  }
  if (/shipped/.test(s)) {
    return 'Shipped';
  }
  if (/hold|hold licensing|awaiting shipping documents/.test(s)) {
    return 'Hold';
  }

  return '';
}

methods.onTabChange = function (tab) {
  this.activeTab = tab;
    if (tab === 'Alerts' && !this.alertsLoaded && !this.alertsLoading) {
      this.alertsLoading = true;
      this.getReleaseChanges()
        .finally(() => { this.alertsLoaded = true; this.alertsLoading = false; });
    }
}

methods.configureColor = function (status) {
  // Normalize first so we always color by canonical label
  const label = this.getStatusLabel(status);

  switch (label) {
    case 'Hold':             return 'danger';
    case 'Pending Customer': return 'warning';
    case 'In Progress':      return 'warning';
    case 'In Production':    return 'success';     // use 'success' if that's your convention
    case 'Shipped':          return 'success';
    case 'Pending':          return 'secondary';
    default:                 return 'info';     // safe fallback
  }
}

methods.goToOrder = function (item) {
  const so_number = item.so_number
  console.log('this is the so nummmmmmmmmmmber', so_number)

  axios.post(
    `${this.$apiAdress}/api/orders/getOrderGroupId?token=${localStorage.getItem('api_token')}`,
    {so_number}
  )
  .then((res) => {
    const row = res.data
    if (!row) return

    const order_id        = row.order_id || ''
    const order_group_id  = row.order_group_id || ''

    console.log('id NUMMiessss------', order_id, order_group_id)

    item.read_at          = true

    this.$router.push('/order/' + order_id + '/' + order_group_id)
  })
  .catch(err => {
    console.error(
      // '[OpenOrdersTable] getCsrOrders failed:',
      err?.response?.release_status_label,
      err?.response?.data || err?.message || err
    )
  })
  .finally(() => {
    this.loading = false
  })
}

export default {
  name: 'CsrOpenOrders',
  components: { 
    DatePicker,
    AdobePdfViewer
  },
  props: {
    csr: {
      type: Object,
      default: null
    },
    customer_selected: {
      type: Object,
      default: null
    }
  },
  data(){
      return{
        orders: null,
        fieldsMain: ['log_number', 'so_number', 'order_date', 'customer_name', 'po_number', 'program_name', 'units', 'total_dollars'],
        fieldsAlerts: ['prev_status', 'release_status_label', 'recent_status_changed_at', 'log_number', 'so_number', 'order_date', 'customer_name', 'po_number', 'program_name', 'units', 'total_dollars'],
        filter: 'Last 15 Days',
        filterOptions: ['Last 15 Days', 'Last 30 Days', 'Last 60 Days', 'All'],
        orderOptionSelected: 'Open Orders',
        orderOptions: ['Open Orders', 'POs Shipped', 'Recent Orders'],
        loading: true,
        customerOptions: null,
        customerFilter: '',
        downloadLoading: false,
        selected: [],
        showAll: false,
        startDate: '',
        endDate: '',
        pdfModal: false,
        pdfData: null,
        activeTab: 'All',
        alertsLoaded: false,
        alertsLoading: false,
        releaseChanges: [],
        collapsed: false
      }
  },

  computed: {
    // tableFields () {
    //   return [
    //     { key: 'so_number',            label: 'Order Number' },
    //     { key: 'order_date',           label: 'Order Date' },
    //     { key: 'customer_name',        label: 'Customer' },
    //     { key: 'po_number',            label: 'Po Number' },
    //     { key: 'program_name',         label: 'Program' },
    //     { key: 'units',                label: 'Total Units' },
    //     { key: 'total_dollars',        label: 'Order Total' },
    //     { key: 'date_shipped',         label: 'Ship Date' },        // or 'date_shipped' if you prefer actual ship
    //     { key: 'release_status_label', label: 'Status' },
    //     { key: 'alert',                label: 'Alert' },            // stays blank for now
    //   ]
    // },
    // rowsForTable () {
    //   const keys = this.tableFields.map(f => (typeof f === 'string' ? f : f.key))
    //   return (this.orders || []).map(row => {
    //     const out = {}
    //     for (const k of keys) out[k] = (row && row[k] != null) ? row[k] : '' // stays blank for now. change to any string value to default a null value
    //     return out
    //   })
    // },
    tabCounts () {
        const arr = Array.isArray(this.orders) ? this.orders : [];

        const Pending = o =>
          /pending|not released/i.test(o.release_status_label || '');

        const inProgress = o =>
          /coloring|order entry|sent to art (stitchout)|sent to art (component)|sent to art (artpack)|sent to art (import)|sent to art (world emblem)/i.test(o.release_status_label || '');

        const pendingCustomer = o =>
          /sent off for approval|waiting on customer/i.test(o.release_status_label || '');

        const isInProd = o =>
          /released|direct ship\/projection/i.test(o.release_status_label || '');

        const isShipped = o =>
          /shipped/i.test(o.release_status_label || '');

        return {
          all: arr.length,
          pending: arr.filter(Pending).length,
          inProgress: arr.filter(inProgress).length,
          pendingCustomer: arr.filter(pendingCustomer).length,
          alerts: Array.isArray(this.releaseChanges) ? this.releaseChanges.length : 0,
          inProd: arr.filter(isInProd).length,
          shipped: arr.filter(isShipped).length,
        };
      },

      displayedOrders () {
        const arr = Array.isArray(this.orders) ? this.orders : [];

        // Alerts tab shows ONLY the getReleaseChanges dataset
        if (this.activeTab === 'Alerts') {
          return Array.isArray(this.releaseChanges) ? this.releaseChanges : [];
        }

        const statusMatches = (tab, release_status_label) => {
          if (tab === 'All') return true;
          const s = String(release_status_label || '').toLowerCase();
          if (tab === 'Pending')       return /pending|not released/.test(s);
          if (tab === 'In Progress')       return /in process|coloring|order entry|sent to art (stitchout)|sent to art (component)|sent to art (artpack)|sent to art (import)|sent to art (world emblem)/.test(s);
          if (tab === 'Pending Customer')       return /sent off for approval|waiting on customer/.test(s);
          if (tab === 'In Production') return /released|direct ship\/projection/.test(s);
          if (tab === 'Shipped')       return /shipped/.test(s);
          if (tab === 'Alerts')        return false;
          return true;
        };

        return arr.filter(o => statusMatches(this.activeTab, o.release_status_label));
      }
  },



  methods: methods,

  watch: {
    csr: {
      immediate: false,
      handler (val) {
        if (val && val.id && this.collapsed) {
          this.getNewOrders()
        }
      }
    },
    customer_selected () {
      if (this.csr && this.csr.id && this.collapsed) {
        this.getNewOrders()
      }
    },
    activeTab (val) {
      if (val === 'Alerts' && !this.alertsLoaded && !this.alertsLoading) {
        this.alertsLoading = true;
        this.getReleaseChanges()
          .finally(() => { this.alertsLoaded = true; this.alertsLoading = false; });
      }
    }
  },



  mounted () {
    this.collapsed = false   // start closed
    // this.getNewOrders()
    // this.getSavedOrders()
    // this.getOrders()
  }
}
</script>

<style scoped>
/* tabs */
.tabs-wrapper { font-family: sans-serif; }
.nav-tabs {
  display: flex;
  border-bottom: 1px solid #ccc;
  padding-left: 0;
  margin-bottom: 10px;
}
.nav-tabs li {
  font-size: 16px;
  list-style: none;
  padding: 10px 20px;
  cursor: pointer;
  border: 1px solid #ccc;
  border-bottom: none;
  background-color: #f7f7f7;
  margin-right: 5px;
}
.nav-tabs li.active {
  background-color: #fff;
  border-top: 3px solid #000;
  font-weight: bold;
}

.date-filters {
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
  align-items: center;
}

.date-filters input {
  padding: 5px;
  width: 120px;
}

.fw-600 { font-weight: 600; }

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.filters-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.filters-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.filters-right {
  display: flex;
  align-items: center;
}

.dp-compact {
  height: 30px !important;
  padding: 2px 8px !important;
  font-size: 0.9rem !important;
}

.so-num {
  font-weight: 600;
  text-decoration: underline;
}

td.event-row,
.event-row td {
  background-color: #9ccdfb !important;
  border: 1px solid gray;
}


</style>
